const SLA_GROUPS_URL = '/api/slaGroups';

export class SlaGroupApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSlaGroups() {
    return this.#http.get(SLA_GROUPS_URL, { params: { includeGlobal: true } });
  }

  async createSlaGroup(body) {
    return this.#http.post(SLA_GROUPS_URL, body);
  }

  async editSlaGroup({ slaGroupId, ...body }) {
    return this.#http.put(`${SLA_GROUPS_URL}/${slaGroupId}`, body);
  }

  async deleteSlaGroup({ slaGroupId }) {
    return this.#http.delete(`${SLA_GROUPS_URL}/${slaGroupId}`);
  }

  async createSlaGroupSlaLevels({ slaGroupId, ...body }) {
    return this.#http.post(`${SLA_GROUPS_URL}/${slaGroupId}/slaLevels`, body);
  }

  async editSlaGroupSlaLevels({ slaGroupId, slaLevelId, ...body }) {
    return this.#http.put(`${SLA_GROUPS_URL}/${slaGroupId}/slaLevels/${slaLevelId}`, body);
  }

  async deleteSlaGroupSlaLevels({ slaGroupId, slaLevelId }) {
    return this.#http.delete(`${SLA_GROUPS_URL}/${slaGroupId}/slaLevels/${slaLevelId}`);
  }

  async reorderSlaLevels({ slaGroupId, ...body }) {
    return this.#http.post(`${SLA_GROUPS_URL}/${slaGroupId}/slaLevels/reorder`, body);
  }
}
